import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import { CurrencyInput, GInput, InputLabeledContainer, InputOnlyDivContainer, NumberInput } from 'tennders-common/form/components'
import { withSendOffer } from 'tennders-market/offer/hocs/withSendOffer'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import Location from 'tennders-common/form/components/new-inputs/Location'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import OfferSentMessage from './OfferSentMessage'

const FirstOfferToLoad = ({
  transaction, submitting, sendBid, pickup,
  errors, setstep, step, onChange, savingRoute,
  setpickup, form, reset, selectedDistance
}) => {
  const { t } = useTranslation()

  return (
    <table className="w-100">
      <tbody>
        <tr>
          <td colSpan="2" className="tennders-offer-panel-table w-100 p-0 pos-rel">
            <div className="w-90 bg-color-white pos-rel p-8">
              <div className="d-flex align-center justify-space pos-rel border-b">
                <div className="w-50">
                  <div className="p-10">
                    <div className="d-flex align-center">
                      <div className="step-no mr-10">1</div>
                      <div className="flex-1"><Trans i18nKey="offer:addTruckStartPosMsg" /></div>
                    </div>
                  </div>
                </div>
                <div className="w-50 text-right">
                  <InputOnlyDivContainer
                    className="pos-rel p-10 d-flex"
                    renderInput={(props) => (
                      <Location
                        {...props}
                        className="form-input w-autos small mr-4"
                        onSet={value => setpickup(prev => ({ ...prev, location: value }))}
                        value={pickup?.location?.label}
                      />
                    )}
                  >
                    <GHref
                      onClick={() => setstep(1)}
                      disabled={!pickup.location}
                      className="btn standard-btn ml-10 small bold confirm-step-btn"
                    >
                      <Trans i18nKey="offer:confirm" />
                    </GHref>
                  </InputOnlyDivContainer>
                </div>
                {step > 0 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>
              <div className="d-flex justify-space pos-rel border-b">
                <div className="w-100">
                  <div className="p-10">
                    <div className="d-flex">
                      <div className="step-no mr-10">2</div>
                      <div className="flex-1">
                        <p>
                          {t('transaction:confirmSelectedRoute')}
                          <br />
                          {t('transaction:dragBetween')}
                        </p>
                        <p>
                          {t('transaction:selectedDistance')}:
                          {' '}
                          {' '}
                          <strong>
                            <DistanceInKm value={selectedDistance} />
                          </strong>
                        </p>
                        {form?.emptyKm && (
                          <p>
                            {t('transaction:emptyKmDistance')}:
                            {' '}
                            <strong>
                              <DistanceInKm value={form?.emptyKm} />
                            </strong>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="ml-40">
                      <div>
                        <GHref
                          disabled={step < 1 || !selectedDistance}
                          onClick={() => setstep(2)}
                          className="btn standard-btn small  bold confirm-step-btn-2"
                        >
                          <Trans i18nKey="offer:confirmRoute" />
                        </GHref>
                      </div>
                    </div>
                  </div>
                </div>
                {step > 1 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>
              <div className="d-flex justify-space pos-rel border-b">
                <div>
                  <div className="p-10">
                    <div className="d-flex align-center">
                      <div className="step-no mr-10">3</div>
                      <div className="flex-1">{t('transaction:enterBid')}</div>
                    </div>
                    <div className="italic ml-40">
                      {transaction?.matchedLoad?.targetPrice ? (
                        <>
                          {t('transaction:preferredPriceIs', { company: transaction?.matchedLoad?.company?.name || t('transaction:theCompany') })}
                          {' '}
                          <GCurrency value={transaction?.matchedLoad?.targetPrice} />
                          {' '}
                          {transaction?.matchedLoad?.priceType}
                          {' '}
                          {t('transaction:paymentTermsAre')}
                          {' '}
                          {transaction?.matchedLoad?.paymentTerm?.days}
                          {' '}
                          {t('transaction:days')}
                        </>
                      ) : <>{t('transaction:noPreferredPrice')}</>}
                    </div>
                    <div className="mt-20">
                      <div className="d-flex">
                        <InputLabeledContainer
                          name="bid"
                          className="mr-20"
                          labelClassName="form-label"
                          label={`${t('offer:enterYourOffer')}`}
                          form={form}
                          required
                          errors={errors}
                          onChange={onChange}
                          renderInput={(rest) => (
                            <CurrencyInput
                              className="form-input w-auto"
                              currency="€"
                              placeholder={`${t('offer:yourPrice')} €`}
                              {...rest}
                            />
                          )}
                        />
                        {transaction.isNegotiable && (
                          <InputLabeledContainer
                            name="paymentTerm"
                            className="mr-20"
                            labelClassName="form-label"
                            label={`${t('offer:paymentTerms')} (${t('offer:optional')})`}
                            form={form}
                            errors={errors}
                            onChange={onChange}
                            renderInput={(rest) => (
                              <NumberInput
                                className="form-input w-auto"
                                placeholder={`${t('offer:paymentTerms')} ${t('offer:days')}`}
                                {...rest}
                              />
                            )}
                          />
                        )}
                      </div>
                      <GHref
                        onClick={reset}
                        disabled={step === 0}
                        className="btn standard-btn small bold confirm-step-btn-3 mt-16 mr-8"
                      >
                        {t('transaction:startOver')}
                      </GHref>
                      <GHref
                        submitting={submitting}
                        onClick={sendBid}
                        disabled={!form.bid || step !== 2 || submitting}
                        className="btn standard-btn  mr-8 small bold confirm-step-btn-3 mt-16"
                      >
                        {savingRoute ? <>{t('transaction:savingRoute')}... </> : <Trans i18nKey="offer:sendBid" />}
                      </GHref>
                    </div>
                  </div>
                </div>
                {step > 2 && (
                  <div className="checked-step">
                    <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
                  </div>
                )}
              </div>

            </div>
            {
              step > 2 && <OfferSentMessage form={form} />
            }
          </td>
        </tr>
      </tbody>
    </table>

  )
}

export default withSendOffer(FirstOfferToLoad)
